<template>
  <div class="form-group">
    <label class="control-label">Transportes</label>
    <b-row class="my-2">
      <b-col>
        <textarea v-model="transports_desc" class="form-control" disabled></textarea>
      </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col cols="10">
        <b-form-select class="form-control" v-model="transportId">
            <option :value="null">Ninguno</option>
            <option v-for="transport in transports" :key="transport.id" :value="transport.id">{{ transport.name }}</option>
        </b-form-select>
      </b-col>
      <b-col cols="2">
        <input type="button" @click="addTransport()" id="addT" class="btn btn-sm btn-light glyphicon glyphicon-ok ml-2" value="+"/>
        <input type="button" @click="removeTransport()" id="remT" class="btn btn-sm btn-light glyphicon glyphicon-minus" value="-"/>
      </b-col>
    </b-row>
  </div> 


</template>

<script>
import { mapState } from 'vuex';

  export default {
    data() {
      return {
        selectedTransports: [],
        transportId:null,
        transports_desc:""
      }
    },
    mounted() {
    },
    computed: {
      ...mapState('transports',{
        transports: state => state.transports
      }),
    },
    created() {
      this.$store.dispatch('transports/getTransports')
    },
    methods: {
      
      setInitialValues() {     
        if(this.initialTransports == null)
          this.selectedTransports = [];
        else
          this.selectedTransports = this.initialTransports.map(t=>t.id);
      },
      addTransport(){
        if(this.selectedTransports.includes(this.transportId))
          return;
        this.selectedTransports.push(this.transportId);
      },
      removeTransport(){
        if(!this.selectedTransports.includes(this.transportId))
          return;
        this.selectedTransports = this.selectedTransports.filter(t => t != this.transportId)
      }
    },
    watch: {
      selectedTransports: function(value) {
        var names_list = this.selectedTransports.map((id) => {
          var t = this.transports.filter(t => t.id == id)[0];
          return t.name + (t.phone_1 != null ? ' (' +t.phone_1+')':'');
        });
        const initialValue = "";
        this.transports_desc = names_list.reduce(
          (accumulator, currentValue) => accumulator + " - " + currentValue, initialValue );
        this.$emit('updateTransports',this.selectedTransports);
      },
      initialTransports: function(value) {
        this.setInitialValues();
      },
    },
    props: [
      'initialTransports'
    ],
    

  }
</script>